import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {DateFormatService} from 'dmmp-services'

@Component({
  selector: 'dmmp-card-new',
  templateUrl: './card-new.component.html',
})
export class CardNewComponent implements OnInit {
  @Input() path
  @Input() image
  @Input() featured
  @Input() categories
  @Input() date
  @Input() title
  @Input() description
  @Input() quantityDescription
  @Input() defaultClass
  @Input() identifier
  @Output() page = new EventEmitter()
  medias = [
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:351px)'},
    {style: 'max_325x325', media: '(max-width:350px)'},
  ]

  constructor(private dateFormat: DateFormatService) {
  }

  ngOnInit() {
    this.date = this.dateFormat.convertFromTimestampToDate(this.date)
  }
}
